// extracted by mini-css-extract-plugin
export default {"root":"UppyWrapper_root__YnAXL"};